import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/stat';

export const GrowthLogAPI = {
    /**
     * 打点
     */
    GROWTH_LOG: {
        url: `${BasePath}/log`,
        type: API_TYPE.GET,
    },
};
